import { createContext, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { GetRolesAPI } from '../API/LoginAPI';
import { IAuthContextProps } from '../Interfaces/IAuthContextProps';
import { IChildrenProps } from '../Interfaces/IChildrenProps';
import { IResponseProps } from '../Interfaces/IResponseProps';
import { ClearSession, GetRolesSession, GetUserSession, SetRolesSession, SetUserSession } from '../Utils/StorageSessions';

export const AuthContext = createContext({} as IAuthContextProps);

const AuthContextProvider = ({ children }: IChildrenProps) => {
    const [roles, setRoles] = useState<string[]>(() => {
        const rol = GetRolesSession();

        if (rol != "") {
            const rolParsed = JSON.parse(rol);
            return rolParsed;
        }

        return [];
    });
    const [userEmail, setUserEmail] = useState<string>(() => {
        const user = GetUserSession();

        if (user != "") {
            const userParsed = JSON.parse(user);
            return userParsed;
        }

        return "";
    });
    const isAuthenticated = !!userEmail;

    const handleLogin = async (email: string, tenantId: string) => {
        var status = 0;

        try {
            await GetRolesAPI(tenantId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    SetUserSession(email);
                    SetRolesSession(resp.data.roles);
                    setUserEmail(email);
                    setRoles(resp.data.roles);
                }
                status = resp.statusCode;
            });
        } catch (error: any) {
            toast.error(error);
            status = 500;
        }

        return status;
    }

    const handleLogout = () => {
        setUserEmail("");
        ClearSession();
    }

    const value = useMemo(
        () => ({ userEmail, isAuthenticated, handleLogin, handleLogout, roles }),
        [userEmail, roles]
    );

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider;
